import { theme } from '@nobia/zeus-components/lib/styled'

export default {
  section: {
    bgColor: '#FAF5F2',
    color: '#000',
    fontSize: '26px',
    fontWeight: '500',
  },
  banner: {
    color: '#fff',
    bgColor: theme('colors.primary'),
  },
  tooltip: {
    color: '#fff',
    bgColor: '#333',
  },
  card: {
    border: {
      selected: '#000',
      default: '#FAF5F2',
    },
  },
  font: {
    headings: {
      fontFamily: 'NewSpirit-Medium, serif',
      fontWeight: '500',
      title: {
        fontSizeSm: '34px',
        lineHeightSm: '40px',
        fontSizeLg: '56px',
        lineHeightLg: '64px',
      },
    },
    preamble: {
      fontFamily: 'Campton, serif',
      fontWeight: '350'
    },
    paragraph: {
      fontFamily: 'NewSpirit-Light, serif',
    },
    strong: {
      fontWeight: '500',
    },
    select: {
      fontFamily: 'Campton',
      fontWeight: '350',
    },
  },
  button: {
    fontWeight: '500',
    padding: '15px',
  },
  costSummary: {
    totalCost: {
      fontSize: '16px',
    },
    link: {
      fontSize: '13px',
    },
  },
  email: {
    error: {
      color: 'red',
    },
    label: {
      fontSize: '16px',
    },
    wrapper: {
      minWidth: '300px',
    },
    padding: '40px 70px',
  },
  badaPromo: {
    image: {
      maxWidth: '550px',
    },
    wrapper: {
      padding: '80px 96px',
    },
  },
  summary: {
    paddingRight: '10px',
    mobile: {
      paddingRight: '0px',
    },
  },
  colors: {
    toneA: '#FAF5F2',
    banner: theme('colors.primary'),
    button: theme('colors.primary'),
  },
}
